import { Button } from "../ui/button";

const fmt = (n) => `₹${Math.round(n || 0).toLocaleString("en-IN")}`;

export function BookingsList({ bookings, plots, admin, onSetStatus }) {
  return (
    <div className="border border-border rounded-lg bg-card divide-y divide-border" data-testid="bookings-list">
      {bookings.length === 0 && <div className="p-6 text-sm text-muted-foreground">No bookings.</div>}
      {bookings.map((b) => {
        const plot = plots.find((p) => p.id === b.plot_id);
        return (
          <div key={b.id} className="p-4 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="text-sm font-medium">Plot {plot?.plot_number || b.plot_id.slice(0, 6)} · {b.guests} guest(s) · {b.nights || "?"} night{(b.nights || 1) === 1 ? "" : "s"}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{b.check_in} → {b.check_out}</div>
              {b.total_price > 0 && (
                <div className="text-xs mt-1">
                  <span className="font-semibold">{fmt(b.total_price)}</span>
                  {b.discount_amount > 0 && (
                    <span className="text-muted-foreground ml-2 line-through">{fmt(b.base_price)}</span>
                  )}
                  {b.discount_amount > 0 && (
                    <span className="text-primary font-semibold ml-2">−{fmt(b.discount_amount)}</span>
                  )}
                </div>
              )}
              {admin && <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1">By {b.customer_name}</div>}
            </div>
            <div className="flex items-center gap-2">
              <span className={`status-pill status-${b.status}`}>{b.status}</span>
              {b.sister_discount_percent != null && (
                <span className="text-[10px] uppercase tracking-widest bg-primary/10 text-primary font-semibold rounded px-2 py-1" data-testid={`sister-discount-${b.id}`}>
                  -{b.sister_discount_percent}% sister
                </span>
              )}
              {admin && b.status === "pending" && (
                <>
                  <Button size="sm" onClick={() => onSetStatus(b.id, "confirmed")} data-testid={`confirm-${b.id}`}>Confirm</Button>
                  <Button size="sm" variant="outline" onClick={() => onSetStatus(b.id, "cancelled")} data-testid={`reject-${b.id}`}>Reject</Button>
                </>
              )}
              {!admin && (b.status === "pending" || b.status === "confirmed") && (
                <Button size="sm" variant="outline" onClick={() => onSetStatus(b.id, "cancelled")} data-testid={`cancel-${b.id}`}>Cancel</Button>
              )}
            </div>
            {b.guest_rsvps && b.guest_rsvps.length > 0 && (
              <div className="w-full mt-2 text-[11px] text-muted-foreground" data-testid={`rsvp-${b.id}`}>
                <span className="uppercase tracking-widest text-[10px] font-semibold mr-2">Guests</span>
                {b.guest_rsvps.map((r) => (
                  <span key={r.email} className="mr-3">
                    {r.email} · <span className={
                      r.status === "confirmed" ? "text-primary font-semibold" :
                      r.status === "declined" ? "text-destructive font-semibold" :
                      ""
                    }>{r.status}</span>
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
